import { Injectable, ElementRef } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class AnimationService {
  private _observers: Map<number, IntersectionObserver> = new Map();

  constructor() {}

  public observeElement(element: ElementRef, threshold: number = 0.4): void {
    const observer = this._getObserver(threshold);
    observer.observe(element.nativeElement);
  }

  private _getObserver(threshold: number): IntersectionObserver {
    if (!this._observers.has(threshold)) {
      const observer = new IntersectionObserver(this._handleIntersect.bind(this), {
        threshold,
      });
      this._observers.set(threshold, observer);
    }
    return this._observers.get(threshold)!;
  }

  private _handleIntersect(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("endOfAnimation");
        this._observers.forEach((observer) => observer.unobserve(entry.target));
      }
    });
  }
}
